import { Injectable } from "@angular/core";
import { ShowToastResult, ToastService } from "@siemens/ix-angular";
import { ToastConfig } from "node_modules/@siemens/ix-angular/toast/toast.config";

/** Used to define global toast config defaults */
@Injectable()
export class AppToastService extends ToastService {
  public override show(config: ToastConfig): Promise<ShowToastResult> {
    if (config.autoCloseDelay === undefined) {
      config.autoCloseDelay = 8000;
    }
    return super.show(config);
  }
}
